import { create } from 'zustand';

interface ProductDetailDialogState {
    isOpen: boolean;
    productId: string | null;
    open: (projectId: string) => void;
    setOpen: (open: boolean) => void;
    close: () => void;
}

const useProductDetailDialogStore = create<ProductDetailDialogState>(set => ({
    isOpen: false,
    setOpen: isOpen => set({ isOpen }),
    productId: null,
    open: (productId: string) => set({ isOpen: true, productId }),
    close: () => set({ isOpen: false }),
}));

export const useProductDetailDialog = () => {
    const { isOpen, productId, open, close, setOpen } = useProductDetailDialogStore();

    return {
        isOpen,
        productId,
        open,
        close,
        setOpen,
    };
};
